import { useEffect } from 'react';
import { useSound } from '../contexts/SoundContext';

export function AudioUnlocker() {
    const { ready } = useSound();

    useEffect(() => {
        if (!ready) return;

        const unlock = async () => {
            const audio = document.createElement('audio');
            audio.src = '/sounds/notification.wav';
            audio.volume = 0;
            try {
                await audio.play();
                audio.pause();
                console.log('[AudioUnlocker] unlocked on page interaction ✅');
            } catch (_) { }
        };

        ['click', 'keydown', 'touchstart', 'scroll'].forEach(e =>
            document.addEventListener(e, unlock, { once: true, passive: true })
        );

        return () => {
            ['click', 'keydown', 'touchstart', 'scroll'].forEach(e =>
                document.removeEventListener(e, unlock)
            );
        };
    }, [ready]);

    return null;
}